import appCONST from 'constants/app.constants';
import appEvents from 'constants/appEvents.constant';

export default function AuthenticationInterceptor($httpProvider) {
    'ngInject';

    $httpProvider.interceptors.push((
        $rootScope,
        $q,
        $injector,
        $window,
        sessionService,
        authService,
        localeService
    ) => {
                    'ngInject';

                    let tokenRequest = null;

                    function refreshToken(config) {
                        setTokenToHeaders(config);

                        if (!authService.isTokenExpired() || authService.isAuthorizedAgentUrl()) {
                            return config;
                        }

                        if (tokenRequest) {
                            return modifyConfigWhenTokenWillBeRefreshed(config);
                        }
                        const grantType = 'refresh_token';
                        const token = sessionService.getSessionItem('refreshToken');

                        const url = `${appCONST.serverUrl}/token`;
                        const queryString = $.param({
                            refresh_token: token, // eslint-disable-line
                            grant_type: grantType, // eslint-disable-line
                        });

                        tokenRequest = $injector.get('$http')
                            .post(url, queryString)
                            .catch(authService.logout);

                        return modifyConfigWhenTokenWillBeRefreshed(config);
                    }

                    function isTokenOrTemplateRequest(config) {
                        return config && config.url
                            && /(html|\/token|^\/$)/.test(config.url);
                    }

                    return {
                        request: (config) => {
                            const culture = localeService.getCurrentCulture();
                            config.headers['Accept-Language'] = config.culture || culture;
                            if (config.noAuth
                                || isTokenOrTemplateRequest(config)
                                || sessionService.getSessionItem('readOnlyMode')) {
                                return config;
                            }
                            config.headers = config.headers || {};

                            if (authService.isAuthorizedAgentUrl()) {
                                const agentKey = authService.getCachedAgentApiKey();
                                if (agentKey) {
                                    config.headers['Agent-Api-Key'] = agentKey;
                                }
                            }

                            return refreshToken(config);
                        },

                        responseError: (rejection) => {
                            const isBadRequestForToken = rejection.status === 400
                                && isTokenOrTemplateRequest(rejection.config);

                            if (rejection.status === 401 || isBadRequestForToken) {
                                $rootScope.$broadcast(appEvents.LOGOUT);
                            }

                            if (rejection.status === 403 && sessionService.getSessionItem('user')) {
                                $rootScope.$broadcast(appEvents.REDIRECT_TO_DEFAULT);
                            }

                            return $q.reject(rejection);
                        },
                    };

                    function setTokenToHeaders(config) {
                        const token = sessionService.getSessionItem('token');
                        if (token) {
                            config.headers.Authorization = 'Bearer ' + token;
                        }
                    }

                    function modifyConfigWhenTokenWillBeRefreshed(config) {
                        return tokenRequest
                            .then((response) => {
                                if (!(response && angular.isObject(response.data))) {
                                    return config;
                                }
                                const {access_token, refresh_token, expires_in} = response.data;  // eslint-disable-line

                                authService.login(access_token, refresh_token, expires_in);
                                authService.setTokenExpiration(expires_in);

                                $rootScope.$broadcast(appEvents.REFRESH_TOKEN);
                                setTokenToHeaders(config);
                                tokenRequest = null;
                                return config;
                            });
                    }
    });
}



// WEBPACK FOOTER //
// ./src/app/configs/interceptors/authInterceptor.js